import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const exportsAPI = {
    createExport: async (rapportId) => {
        const token = localStorage.getItem('token');
        const response = await axios.post(`${API_URL}/exports`, { rapportId }, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    getJobStatus: async (jobId) => {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/exports/${jobId}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    getMyJobs: async () => {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/exports/my-jobs`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    downloadUrl: (jobId) => {
        const token = localStorage.getItem('token');
        return `${API_URL}/exports/${jobId}/download?token=${token}`;
    },

    deleteJob: async (jobId) => {
        const token = localStorage.getItem('token');
        const response = await axios.delete(`${API_URL}/exports/${jobId}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    }
};

export default exportsAPI;
